import {
	ExarePriceDetail_ExarePriceDetailsPriceElement_Fragment,
	ExarePriceDetail_ExarePriceDetailsTaxElement_Fragment,
	ExarePriceDetailsPriceElementType
} from '@websky/graphql';
import { getZeroPrice } from './getZeroPrice';
import { getTotalPrice } from './getTotalPrice';

export const getTotalPriceFilteredElements = (
	elements:
		| ExarePriceDetail_ExarePriceDetailsPriceElement_Fragment[]
		| ExarePriceDetail_ExarePriceDetailsTaxElement_Fragment[],
	type: ExarePriceDetailsPriceElementType,
	currency: string
) => {
	if (!elements?.length) {
		return getZeroPrice(currency);
	}

	const filteredElements = elements.filter(element => element.type === type);

	return filteredElements.length > 0
		? getTotalPrice(filteredElements, filteredElements => filteredElements.money)
		: getZeroPrice(currency);
};
